<template>
<w-sliding-popup ref="slidingPopup" :title="title" width="1000px" @close="close()">
  <div slot="content" style="height:100%">
    <el-row type="flex" class="title-bar" justify="center">
      <el-col :span="1">
        <el-button @click="setDateParams('pre')"><i class="fas fa-chevron-left"></i></el-button>
      </el-col>
      <el-col :span="12">
        <div class="vertical-center-box" style="justify-content:center;">
          <div class="title-h3">{{dateRange}}</div>
        </div>
      </el-col>
      <el-col :span="1">
        <el-button @click="setDateParams('nexe')"><i class="fas fa-chevron-right"></i></el-button>
      </el-col>
    </el-row>
    <w-analysis-stacked-column-chart ref="analysisStackedColumnChart" :selected-result="selectedResult" :date-params="dateParams" style="height:150px;margin-bottom:20px"></w-analysis-stacked-column-chart>
    <div class="condition-box mr-b10" style="height: 50px">
      <div class="fl-r">
        <ul class="diff-legend-box fl-l mr-t5">
          <li><span class="item added"></span>추가</li>
          <li><span class="item modified"></span>변경</li>
          <li><span class="item deleted"></span>삭제</li>
        </ul>
        <div align="right" class="fl-l mr-l5">
          <el-radio-group class="ordinary cmp-margin-left" size="mini" v-model="diffFlag">
            <el-radio-button :label="true">변경내역만 보기</el-radio-button>
            <el-radio-button :label="false">전체 보기</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="title-bar" type="flex">
      <div class="vertical-center-box" style="width:calc(50% - 15px);">
        <span class="dot-title"></span>
        <el-select v-model="baseExecId" placeholder="수행 결과 선택" @change="compareResultBuffer">
          <el-option v-for="exec in execResultList" :key="exec.triggerExecId" :label="getDateFormatter(exec.startDatetime)" :value="exec.triggerExecId"></el-option>
        </el-select>
        <span class="mr-l4">수행 결과</span>
        <em v-if="isEqualHist" class="mr-l10">동일한 수행 결과입니다.</em>
      </div>
      <div class="mr-l15" style="width:50%;">
        <el-row type="flex" justify="space-between">
          <div class="vertical-center-box">
            <span class="dot-title"></span>
            <el-select v-model="compareExecId" placeholder="수행 결과 선택" @change="compareResultBuffer">
              <el-option v-for="exec in execResultList" :key="exec.triggerExecId" :label="getDateFormatter(exec.startDatetime)" :value="exec.triggerExecId"></el-option>
            </el-select>
            <span class="mr-l4">수행 결과</span>
          </div>
        </el-row>
      </div>
    </div>
    <div style="height: calc(100vh - 500px)">
      <el-scrollbar>
        <div style="width:100%" v-html="showCompareText"></div>
      </el-scrollbar>
    </div>
    <w-execution-result-buffer-popup ref="resultBufferPopup" :selected-result="selectedAnalysisResult"></w-execution-result-buffer-popup>
  </div>
</w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEqual, cloneDeep, isEmpty } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { isTrue } from '@/utils/boolean';
import msgUtil from '@/utils/message';
import AmsResultAPI from '@/api/ams/result';
import WAnalysisStackedColumnChart from '../components/AnalysisStackedColumnChart';
import WExecutionResultBufferPopup from './ExecutionResultBufferPopup';

export default {
  name: 'WExecutionResultAnalysisPopup',
  components: {
    WAnalysisStackedColumnChart,
    WExecutionResultBufferPopup,
  },
  props: {
    selectedResult: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    title() {
      let title = EMPTY_TEXT;
      if (!isNil(this.selectedResult)) {
        title = `[${this.selectedResult.jobName} - ${this.selectedResult.nodeName}] 수행 이력`;
      }
      return title;
    },
    ...mapGetters(['analysisDateParams']),
    dateRange() {
      if (!isNil(this.dateParams)) {
        const startDatetime = this.getDateFormatter(this.dateParams.startDatetime);
        const endDatetime = this.getDateFormatter(this.dateParams.endDatetime);
        return `${startDatetime} ~ ${endDatetime}`;
      }
      return null;
    },
  },
  data() {
    return {
      dateParams: null,
      selectedAnalysisResult: null,
      diffFlag: false,
      isEqualHist: false,
      baseExecId: null,
      compareExecId: null,
      execResultList: [],
      compareData: null,
      showCompareText: '',
      selectExecId: null,
    };
  },
  watch: {
    dateParams(o) {
      if (isNil(o)) {
        this.clearComparedData();
      } else {
        this.loadData();
      }
    },
    diffFlag() {
      this.setShowCompareText();
    },
    selectedResult: {
      handler(rslt) {
        if (!isNil(rslt)) {
          this.selectExecId = rslt.triggerExecId;
        }
      },
      immediate: true,
    },
    showCompareText() {},
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.dateParams = cloneDeep(this.analysisDateParams);
      });
    },
    close() {
      this.dateParams = null;
      this.$refs.slidingPopup.visible = false;
    },
    loadData() {
      const dateParams = this.dateParams;
      const selectedResult = this.selectedResult;
      this.dateParams = dateParams;
      const params = {
        startDatetime: dateParams.startDatetime,
        endDatetime: dateParams.endDatetime,
        triggerId: selectedResult.triggerId,
        jobId: selectedResult.jobId,
        nodeId: selectedResult.nodeId,
      };

      AmsResultAPI.getTrgExecResultBufferChangeHist(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.setExecResult(result.data);
        }
      });
    },
    setExecResult(data) {
      if (!isEmpty(data)) {
        let selectedExecId;
        this.execResultList = data;
        if (!isNil(this.selectExecId)) {
          selectedExecId = this.selectedResult.triggerExecId;
        } else {
          selectedExecId = data[0].triggerExecId;
        }
        const index = this.execResultList.findIndex((result) => result.triggerExecId === selectedExecId);
        this.baseExecId = this.execResultList[index].triggerExecId; // Left: 최근 값
        if (data.length > index + 1) {
          this.compareExecId = this.execResultList[index + 1].triggerExecId; // Right : 이전 값
        } else {
          this.compareExecId = this.execResultList[index].triggerExecId;
        }
        this.compareResultBuffer();
      } else {
        this.baseExecId = null;
        this.compareExecId = null;
        this.clearComparedData();
      }
    },
    getStatusFlagName(row, column, value) {
      if (isEqual(value, 'C')) {
        return '완료';
      } else if (isEqual(value, 'I')) {
        return '진행중';
      }
      return '대기';
    },
    getResultFlagName(row, column, value) {
      if (isEqual(value, 'S')) {
        return '성공';
      }
      return '실패';
    },
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    setDateParams(type) {
      const dateParams = cloneDeep(this.dateParams);
      let startDatetime = dateParams.startDatetime;
      let endDatetime = dateParams.endDatetime;
      const diff = endDatetime - startDatetime;
      if (isEqual(type, 'pre')) {
        const temp = startDatetime;
        startDatetime -= diff;
        endDatetime = temp;
      } else {
        const temp = endDatetime;
        endDatetime += diff;
        startDatetime = temp;
      }
      this.dateParams = {
        startDatetime,
        endDatetime,
      };
      this.selectExecId = null;
    },
    onClickResultButton(row) {
      this.selectedAnalysisResult = row;
      this.$refs.resultBufferPopup.open();
    },
    compareResultBuffer() {
      // 기간선택 후 buffer 비교 로드
      const dateParams = this.dateParams;
      const selectedResult = this.selectedResult;
      this.dateParams = dateParams;
      const params = {
        startDatetime: dateParams.startDatetime,
        endDatetime: dateParams.endDatetime,
        triggerId: selectedResult.triggerId,
        jobId: selectedResult.jobId,
        nodeId: selectedResult.nodeId,
        baseTriggerExecId: this.baseExecId,
        compareTriggerExecId: this.compareExecId,
      };
      this.isEqualHist = this.baseExecId === this.compareExecId;
      AmsResultAPI.getTrgExecResultBufferComparedData(params).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (!isEmpty(data)) {
            this.setComparedData(data);
          } else {
            this.clearComparedData();
          }
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수행 결과', false));
          this.clearComparedData();
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수행 결과', false));
        this.clearComparedData();
      }).finally(() => {
        this.isLoading = false;
      });
    },
    setComparedData(data) {
      this.compareData = data;
      this.diffFlag = isTrue(data.compareData.diffFlag);
      this.setShowCompareText();
    },
    setShowCompareText() {
      this.showCompareText = this.diffFlag ? this.compareData.compareResults.diff : this.compareData.compareResults.compare;
    },
    clearComparedData() {
      this.execResultList = [];
      this.baseExecId = null;
      this.compareExecId = null;
      this.showCompareText = '';
      this.compareData = {};
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/popup/ExecutionResultAnalysisPopup.vue